export interface CategoryLabelInput {
    key: string;
    name: string;
    displayName?: string;
    color?: string;
    publicationDate: boolean;
}

export class CategoryLabel {
    /**
     * Key of the category to be displayed.
     */
    public key: string;

    /**
     * Human readable version og the key
     */
    public name: string;

    /**
     * Label that will be displayed to the end-user
     */
    public displayName: string;

    public color?: string;

    public publicationDate: boolean;

    public constructor(input: CategoryLabelInput) {
        this.key = input.key;
        this.name = input.name;
        this.displayName = input.displayName || input.name;
        if (input.color) {
            this.color = input.color;
        }
        this.publicationDate = input.publicationDate;
    }
}
